import React from 'react';
import ContactInfoWidget from '../Widget/ContactInfoWidget';
import SocialWidget from '../Widget/SocialWidget';
import Newsletter from '../Widget/Newsletter';
import TextWidget from '../Widget/TextWidget';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="cs_footer cs_style_1 cs_heading_color">
      <div
        className="cs_footer_logo_wrap"
        style={{ backgroundImage: 'url(/images/footer_bg_1.svg)' }}
      >
        <div
          className="cs_footer_brand"
          style={{ backgroundImage: 'url(/images/footer_logo_bg.svg)' }}
        >
          <img
            src="/images/logo.svg"
            alt="Logo Icon"
            className="cs_footer_brand_icon"
            width={150}
          />
       
        </div>
      </div>
      <div className="cs_footer_main">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="cs_footer_item">
                <TextWidget text={`${t('footer.brand.title')}  <br />${t('footer.brand.tagline')}`} />
                <ContactInfoWidget />
              </div>
            </div>
            <div className="col-lg-2">
           
            </div>
            <div className="col-lg-2">
              
            </div>
            <div className="col-lg-4">
              <div className="cs_footer_item">
                <Newsletter
                  title={t('footer.newsletter.title')}
                  subTitle={t('footer.newsletter.subTitle')}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="cs_footer_bottom" style={{ backgroundColor: '#0171CE' }}>
        <div className="container">
          <div className="cs_footer_bottom_in">
            <SocialWidget />
            <div className="cs_copyright">
              Copyright © 2025 Transvie All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
